export const GTM_POST_HYDRATION_SCRIPT_ELEMENT_ID = 'gtm-consent-bridge';
